// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const textTypes = [
  "text/plain",
  "text/html",
  "text/csv",
  "text/markdown",
];
